import { Owner as OwnerState, AdmittedStatus} from './types';

export default {
  isLoadingOwner: (state: OwnerState) => (state.status === 'fetching:by-key' || state.status === 'fetching:by-id' || state.status === 'submiting:owner'),
  isLoadingAdmitted: (state: OwnerState) => state.ownerAdmittedStatus === AdmittedStatus.FETCHING,
};
